.banner {
  position: fixed;
  top: var(--app-dev-banner-h, 0);
  left: 0;
  right: 0;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--tuna-typography-fontSize-xs);
  font-weight: 500;
  letter-spacing: 0.02em;
  z-index: 1199;
  pointer-events: none;
  user-select: none;
}

/* Per-tone text color uses each feedback color's OWN contrastText, not the
   primary accent's. White on amber (#f9a825) is ~1.6:1 — a WCAG 1.4.3 fail
   the text-shadow can't rescue; warning-contrastText is #000 (~13:1). */
.info {
  background: var(--tuna-feedback-info);
  color: var(--tuna-palette-info-contrastText);
}

.warning {
  background: var(--tuna-feedback-warning);
  color: var(--tuna-palette-warning-contrastText);
}

/* Idle: keep the live region mounted (so screen readers announce status
   changes) but visually and spatially absent. */
.idle {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
